/* Quick-link intent only: existing Shopify Google tag owns page views/purchases. */
(() => {
  'use strict';
  if (window.hitQuickLinksTracking) return;
  window.hitQuickLinksTracking = true;
  const ids = ['start_here','book_classes','pricing','class_videos','class_videos_2025','manage_membership','studio_hire','teach_at_hit'];
  document.querySelectorAll('nav .quick-link').forEach((a,i) => a.dataset.quickLink = ids[i]);
  let viewed = false;
  function allowed() {
    try { return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  }
  function send(name, params) {
    if (!allowed()) return;
    window.dataLayer = window.dataLayer || [];
    function tag(){ window.dataLayer.push(arguments); }
    tag('event',name,Object.assign({send_to:'G-D35C1X7JN5',page_location:location.origin + location.pathname,transport_type:'beacon'},params));
  }
  function ready() {
    if (!allowed() || viewed) return;
    viewed = true;
    const q = new URLSearchParams(location.search);
    send('quick_links_view',{entry_source:['instagram','ig'].includes((q.get('utm_source') || '').toLowerCase()) ? 'instagram_bio' : 'other'});
  }
  document.addEventListener('visitorConsentCollected',ready);
  if (window.Shopify && window.Shopify.customerPrivacy) ready();
  else if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error => { if (!error) ready(); });
  }
  document.addEventListener('click',event => {
    const a = event.target.closest('a');
    if (!a) return;
    const id = a.dataset.quickLink || (a.classList.contains('brand') ? 'logo_home' : ({'Instagram ↗':'instagram','Email HIT':'email','Visit & contact':'visit','Privacy':'privacy','Terms':'terms'}[a.textContent.trim()]));
    if (!id) return;
    const params = {link_id:id,link_location:a.closest('footer') ? 'footer' : 'main'};
    // Give the existing tag a bounded opportunity to flush before same-tab navigation.
    if (allowed() && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && !a.target && !a.hasAttribute('download')) {
      event.preventDefault();
      let followed = false;
      const follow = () => { if (!followed) { followed = true; location.assign(a.href); } };
      params.event_callback = () => setTimeout(follow,100);
      params.event_timeout = 400;
      setTimeout(follow,400);
    }
    send('quick_link_' + id,params);
  });
})();
